window.isMobile = (function () {
    let flag =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent,
        );
    return flag;
})();

document.addEventListener("DOMContentLoaded", function () {
  const ygSwitcher = document.querySelector(".yg-switcher-btn");

  if (!ygSwitcher) return

  const currentUrl = window.location.href;
  const btns = ygSwitcher.querySelectorAll('button');
  let hostBtn;
  let flag = false;

  btns.forEach(btn => {
    btn.style.display = 'none';
  })

  btns.forEach(btn => {
    const url = btn.getAttribute('data-url');
    const isDefault = btn.getAttribute('data-default');
    if (isDefault === 'true') {
      hostBtn = btn;
      return
    }
    
    if (url && currentUrl.includes(url)) {
      btn.style.display = 'flex';
      flag = true;
    }
  })
  
  if (!flag) {
    hostBtn.style.display = 'flex'
  }
});

class YGScriptLoader extends HTMLElement {
    loadScript(url, fn) {
      if (url) {
        let loadScript = document.createElement('script')
        loadScript.src = url
        document.body.appendChild(loadScript)
  
        loadScript.onload = () => {
          fn()
        }
  
        loadScript.onerror = (err) => {
          console.error(err)
        }
      }
    }
  }